SwiperProducATC = new Swiper('.SwiperProducATC', {
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: '.swiper-paginationATC',
      clickable: true,
    },
    navigation:{
      nextEl: ".swiper-button-nextATC",
      prevEl: ".swiper-button-prevATC"
    },
  });

  document.addEventListener("DOMContentLoaded", function () {
    
    // event track in GA
    document.querySelectorAll(".products-atc__swiper-wrapper > div").forEach(item => {
      item.querySelector("form button").addEventListener("click", e => {
        gtag('event', 'click', {
          'pdp': window.location.pathname
        });
        console.log("%ctga", "font-size: 2rem")
      })
    })
  
  const sectionHugl = document.getElementById("products-atc--template--17185747304674__cross_selling_atc_pdp_drYrTk")
  
  const sectionHuman = document.getElementById("products-atc--template--16845094125794__cross_selling_atc_pdp_a9T7ic") 
    
    if (sectionHuman) {


      const moveSectionThisHuman = document.getElementById("insert-atc-PDP-HUMAN")
      moveSectionThisHuman.appendChild(sectionHuman)
      sectionHuman.style.display = "flex";

      const orderStyle = document.querySelector('[hiddenSwatchOption]');
        
      if (orderStyle) {
        const parentNode = orderStyle.parentElement
    
        if (parentNode) {
          const sibling = parentNode.nextElementSibling.nextElementSibling
          sibling.style.margin = "-20px 0 7px 0"
    
        }
      }

        document.querySelectorAll('.swatch-option').forEach(function(swatchOption, index) {
          swatchOption.addEventListener('click', function() {
            document.querySelectorAll('.swatch-option').forEach(function(e) {
              e.classList.remove('selected');
            });
            
            this.classList.add('selected');
            
            let selectedValue = this.getAttribute("data-value");

            document.querySelectorAll("#upSellPDP").forEach(item => {
              item.value = selectedValue;
            });
          });

          if (index === 0) {
            swatchOption.click();
          }

        });

        SwiperProducATC.on('slideChangeTransitionEnd', function () {
          document.querySelectorAll('.swatch-option').forEach(function (e) {
            e.classList.remove('selected');      
           
          });

          let activeSlide = document.querySelector('#products-atc--template--16845094125794__cross_selling_atc_pdp_a9T7ic .swiper-slide-active');
          let selectedSwatcher = activeSlide.querySelector('.swatch-option:not([hidden])');

          if (selectedSwatcher) {
            selectedSwatcher.classList.add('selected');
            
            let selectedValue = selectedSwatcher.getAttribute("data-value");

            document.querySelectorAll("#upSellPDP").forEach(item => {
              item.value = selectedValue;
            });
          }
        });

        function syncPrices() {
            const dataPrices = document.querySelector(".swatch-option.selected");
            if (dataPrices) {
                let price = dataPrices.getAttribute('data-current-price');
                let comparePrice = dataPrices.getAttribute('data-compare-at-price');
                let changePrice = document.querySelectorAll(".products-atc__price");
                let changeComparePrice = document.querySelectorAll(".products-atc__comparePrice");

                changePrice.forEach(item => item.innerHTML = price);
                changeComparePrice.forEach(item => item.innerHTML = comparePrice);
            }
        }

        const observer = new MutationObserver(mutationsList => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    syncPrices();
                }
            }
        });

        const targetNode = document.querySelector('.swatch-option');
        if (targetNode) {

            observer.observe(targetNode, { attributes: true });
        }

        syncPrices();
      
    }

    if (sectionHugl) {
    
      const moveSectionThisHugl = document.getElementById("insert-atc-PDP-HUGL")
      moveSectionThisHugl.appendChild(sectionHugl)

      sectionHugl.style.display = "flex";
      
      const orderStyle = document.querySelector('[hiddenSwatchOption]');
    
    
      if (orderStyle) {
        const parentNode = orderStyle.parentElement
    
        if (parentNode) {
          const sibling = parentNode.nextElementSibling.nextElementSibling
          sibling.style.margin = "-20px 0 7px 0"
    
        }
      }

        document.querySelectorAll('.swatch-option').forEach(function(swatchOption, index) {
          swatchOption.addEventListener('click', function() {
            document.querySelectorAll('.swatch-option').forEach(function(e) {
              e.classList.remove('selected');

            });

            this.classList.add('selected');

            let selectedValue = this.getAttribute("data-value");

            document.querySelectorAll("#upSellPDP").forEach(item => {
              item.value = selectedValue;
            });
          });

          if (index === 0) {
            swatchOption.click();
          }
        });

        SwiperProducATC.on('slideChangeTransitionEnd', function () {
          document.querySelectorAll('.swatch-option').forEach(function (e) {
            e.classList.remove('selected');      
          });

          let activeSlide = document.querySelector('#products-atc--template--17185747304674__cross_selling_atc_pdp_drYrTk .swiper-slide-active');

          let selectedSwatcher = activeSlide.querySelector('.swatch-option:not([hidden])');

          if (selectedSwatcher) {
            selectedSwatcher.classList.add('selected');
            
            let selectedValue = selectedSwatcher.getAttribute("data-value");

            document.querySelectorAll("#upSellPDP").forEach(item => {
              item.value = selectedValue;
            });
          }
        });

        function syncPrices() {
            const dataPrices = document.querySelector(".swatch-option.selected");
            if (dataPrices) {
                let price = dataPrices.getAttribute('data-current-price');
                let comparePrice = dataPrices.getAttribute('data-compare-at-price');
                let changePrice = document.querySelectorAll(".products-atc__price");
                let changeComparePrice = document.querySelectorAll(".products-atc__comparePrice");

                changePrice.forEach(item => item.innerHTML = price);
                changeComparePrice.forEach(item => item.innerHTML = comparePrice);
            }
        }

        const observer = new MutationObserver(mutationsList => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    syncPrices();
                }
            }
        });

        const targetNode = document.querySelector('.swatch-option');
        if (targetNode) {

            observer.observe(targetNode, { attributes: true });
        }

        syncPrices();
    }

      //Function for badges

      const OrderByHidden = document.querySelector('.order-by');
      const articGreyVariant = document.querySelector('.articGreyVariant');
      const badgeShow = document.querySelector('.badgeInfo__container');
    
      const spanToWatchColors = document.querySelector('[data-select-label="Color"] [data-swapper-target]');
    
      function updateDisplayStyles(displayOrderBy, displayArticGreyVariant, displayBadge) {
        OrderByHidden.style.display = displayOrderBy;
        articGreyVariant.style.display = displayArticGreyVariant;
        badgeShow.style.display = displayBadge;
      }
    
      const observer = new MutationObserver(function(mutationsList) {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.target.textContent === 'Arctic Grey') {
            updateDisplayStyles('none', 'flex', 'none');
          } else {
            updateDisplayStyles('none', 'none', 'flex');
          }
        }
      });
    
      observer.observe(spanToWatchColors, { childList: true });

  })